<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2667 10.6254H12.5C10.425 10.6254 9.375 9.45037 9.375 7.12537V4.73371C9.375 3.88371 9.475 2.66704 10.3583 2.00037C11.1 1.45037 12.1667 1.40871 13.7417 1.86704C15.8083 2.46704 17.5333 4.19204 18.1333 6.25871C18.5917 7.82537 18.55 8.90037 18 9.63371C17.3333 10.5254 16.1167 10.6254 15.2667 10.6254ZM11.9 2.80037C11.5583 2.80037 11.2917 2.86704 11.1167 3.00037C10.7917 3.24204 10.6333 3.80871 10.6333 4.73371V7.13371C10.6333 9.00037 11.35 9.38371 12.5083 9.38371H15.275C16.1917 9.38371 16.7583 9.22537 17.0083 8.90037C17.3 8.51704 17.275 7.75037 16.95 6.62537C16.4667 4.98371 15.05 3.55871 13.4083 3.08371C12.7917 2.89204 12.2917 2.80037 11.9 2.80037Z"
      fill="#667085"
    />
    <path
      d="M9.22502 18.9583C8.78336 18.9583 8.33336 18.9249 7.88336 18.8499C4.47502 18.2999 1.70002 15.5333 1.15002 12.1249C0.441691 7.74161 3.26669 3.60828 7.59169 2.72494C7.93336 2.65828 8.25836 2.87494 8.33336 3.20828C8.40002 3.54994 8.18336 3.87494 7.85002 3.94994C4.19169 4.69994 1.79169 8.19994 2.40002 11.9249C2.86669 14.8083 5.20836 17.1499 8.09169 17.6166C11.8334 18.2166 15.325 15.8083 16.0667 12.1333C16.1334 11.7916 16.4667 11.5749 16.8 11.6416C17.1417 11.7083 17.3584 12.0416 17.2917 12.3749C16.5 16.2666 13.1 18.9583 9.22502 18.9583Z"
      fill="#667085"
    />
  </svg>
</template>
  
<script>
export default {
  name: "DefaultPageIcon",
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    isActive: Boolean,
  },
  data() {
    return {};
  },
};
</script>
